import { useEffect, useRef, useState } from "react";
import { Avatar, Popover, shortName, typeUi, statusUi } from "./timeOffShared";

// Overflow control: an avatar stack + "+N" that, when clicked, lists everyone
// off that day in a popover.
function MoreChip({ requests, all, label, rich = false, onView }) {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);

  // close on outside click
  useEffect(() => {
    if (!open) return;
    const onDown = (e) => {
      const inTrigger = ref.current && ref.current.contains(e.target);
      const inPopover = e.target.closest && e.target.closest("[data-timeoff-popover]");
      if (!inTrigger && !inPopover) setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open]);

  return (
    <>
      <button
        ref={ref}
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1 rounded-full pl-0.5 pr-2 py-0.5 bg-[#F5F5F5]"
      >
        <span className="flex -space-x-1.5">
          {requests.slice(0, 2).map((req) => (
            <Avatar key={req.id} user={req.user} className="w-5 h-5" />
          ))}
        </span>
        <span className="text-center font-OpenSansRegular text-[12px] font-normal leading-[18px] tracking-[0.12px] text-[#404040]">
          +{requests.length}
        </span>
        {/* requests = overflow only; `all` (everyone off that day) is listed in the popover */}
      </button>
      {open && (
        <Popover anchorRef={ref} width={240}>
          <div>
            <div className="flex items-center justify-between mb-2 bg-[#FAFAFA] p-3 rounded-t-lg border-b border-[#EEF0F9]">
              <span className="font-InterSemiBold text-[13px] text-[#1E293B]">{label}</span>
              <button onClick={() => setOpen(false)} className="opacity-70 hover:opacity-100">
                <img src="/images/common/close.svg" alt="Close" className="w-4 h-4" />
              </button>
            </div>
            <div className="flex flex-col gap-1 p-2">
              {all.map((req) => {
                const type = typeUi(req.type);
                const status = statusUi(req.status);
                return (
                  <div
                    key={req.id}
                    onClick={() => {
                      if (rich) {
                        onView?.(req);
                        setOpen(false);
                      }
                    }}
                    className={`flex items-center justify-between gap-2 rounded-lg px-2 py-1.5 hover:bg-[#F8FAFC] ${
                      rich ? "hover:cursor-pointer" : ""
                    }`}
                  >
                    <div className="flex items-center gap-2 min-w-0">
                      <Avatar user={req.user} className="w-6 h-6 shrink-0" />
                      <div className="flex flex-col min-w-0">
                        <span className="truncate font-OpenSansSemiBold text-[12px] leading-[16px] tracking-[0.12px] text-[#0F172A]">
                          {shortName(req.user)}
                        </span>
                        {rich && (
                          <span className="truncate font-OpenSansRegular text-[11px] leading-[14px] text-[#94A3B8]">
                            {type.label}
                          </span>
                        )}
                      </div>
                    </div>
                    {rich && (
                      <span
                        className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-OpenSansSemiBold leading-[14px] ${status.className}`}
                      >
                        {status.label}
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </Popover>
      )}
    </>
  );
}

export default MoreChip;
